import { render } from "./Linkedin.vue?vue&type=template&id=e99601be"
import script from "./Linkedin.vue?vue&type=script&lang=js"
export * from "./Linkedin.vue?vue&type=script&lang=js"

import "./Linkedin.vue?vue&type=style&index=0&id=e99601be&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__